import PageHome from "./home/page-home.vue";

export default [
  {
    path: "/",
    component: PageHome,
  },
];
